import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 91ED2206-4D41-48DB-964F-5E3AC50F899D
 * name align-horizontal-left
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/align-horizontal-left.svg
 * tags
 */
export const AlignHorizontalLeftIcon = createSvgIcon(<><path d="M4 22H2V2H4V22M22 7H6V10H22V7M16 14H6V17H16V14Z" /></>, 'AlignHorizontalLeftIcon');
export default AlignHorizontalLeftIcon